import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Table = _resolveComponent("Table");
    return (_ctx.countsTableData !== null)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _createVNode(_component_Table, {
                tableData: _ctx.lipinskiTableData,
                caption: "Lipinski Properties"
            }, null, 8, ["tableData"]),
            _createVNode(_component_Table, {
                tableData: _ctx.otherTableData,
                caption: "Other Properties"
            }, null, 8, ["tableData"]),
            _createVNode(_component_Table, {
                tableData: _ctx.countsTableData,
                caption: "Counts"
            }, null, 8, ["tableData"])
        ]))
        : _createCommentVNode("", true);
}
